import { FC } from 'react';

import { Box } from '@qwealth/qcore';

import { useAppSelector } from 'data/store';
import { selectKypIsLoading, selectKyps } from 'data/selectors/kypSelectors';
import { Kyp } from 'data/models/Kyp';
import TransitionBox from 'components/Households/Common/QNotes/TransitionBox';
import KypCsvButton from './KypCsvButton';

const KypTableFooter: FC = (): JSX.Element => {
  const isLoading = useAppSelector<boolean>(selectKypIsLoading);
  const kyps = useAppSelector<Kyp[]>(selectKyps);

  return (
    <TransitionBox index={10} isVisible={!isLoading}>
      {!isLoading && (
        <Box display="flex" justifyContent="space-between" alignItems="center" marginTop="default">
          <Box fontWeight="bold">Showing {kyps.length > 1 ? kyps.length : 0} results</Box>
          <Box>
            <KypCsvButton />
          </Box>
        </Box>
      )}
    </TransitionBox>
  );
};

export default KypTableFooter;
